import { createContext, useContext } from 'react';

export const ThemeContext = createContext();
export const BoardContext = createContext(null);
export const useBoardContext = () => useContext(BoardContext);
